import providerInstance from "../api-provider";
import billingInstance from "../api-billing";
import handleError from "../handleError";

export const searchPatient = async (payload, token) => {
  try {
    let { data } = await providerInstance({
      url: "/provider/searchPatient",
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      data: payload,
    });
    return data;
  } catch (error) {
    handleError(error);
  }
};

// export const editPatient = async (payload, token) => {
//   try {
//     let { data } = await providerInstance({
//       url: "/provider/editPatient",
//       method: "POST",
//       headers: {
//         "Content-Type": "application/json",
//         Authorization: `Bearer ${token}`,
//       },
//       data: payload,
//     });
//     return data;
//   } catch (error) {
//     handleError(error);
//   }
// };

export const getPatientInsuranceList = async (payload, token) => {
  try {
    let { data } = await providerInstance({
      url: "/provider/getPatientInsuranceList",
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      data: payload,
    });
    return data;
  } catch (error) {
    handleError(error);
  }
};

export const addPatientInsurance = async (payload, token) => {
  try {
    let { data } = await providerInstance({
      url: "/provider/addPatientInsurance",
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      data: payload,
    });
    return data;
  } catch (error) {
    handleError(error);
  }
};
export const updatePatientInsurance = async (payload, token) => {
  try {
    let { data } = await providerInstance({
      url: "/provider/updatePatientInsurance",
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      data: payload,
    });
    return data;
  } catch (error) {
    handleError(error);
  }
};
export const updatePatientVerification = async (payload, token) => {
  try {
    let { data } = await providerInstance({
      url: "/provider/updatePatientVerification",
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      data: payload,
    });
    return data;
  } catch (error) {
    handleError(error);
  }
};

export const confirmAppointment = async (payload, token) => {
  try {
    let { data } = await providerInstance({
      url: "/provider/confirmAppointment",
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      data: payload,
    });
    return data;
  } catch (error) {
    handleError(error);
  }
};

export const getPayerMaster = async (payload, token) => {
  try {
    let { data } = await billingInstance({
      url: "/getPayerMaster",
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      data: payload,
    });
    return data?.map((c) => ({
      ...c,
      fullText: `${c.payer_id} ${c.payer_name}`,
    }));
  } catch (error) {
    handleError(error);
  }
};
